import React from 'react'

function About() {
  return (
    <div className='container'>
        <div className="about-box">
            <h3 className='text-center'>PolyA2z - About</h3>
            <h6>Welcome to PolyA2z,</h6>
            <p>On our PolyA2z Website, we promise you to provide you all the resources required for studying any Diploma course(Polytechnic). The key that makes PolyA2z a unique place for Students is that we have each and every resource in both English & Hindi Language. We always try to keep our resources updated. Our website covers the full syllabus of any subject. The notes are verified twice, but incase of any wrong solution we are not responsible for any Loss, If any information found wrong please consider to mail us.
            </p>
            <h6 className="text-center">
                List of Resources that we provide
            </h6>
            <ul>
                <li>Notes of all Chapters.</li> 
                <li>Simplified Syllabus</li>
                <li>Previous year Question</li>
                <li>All Important Questions</li>
                <li>Modal Papers & much more....</li>
            </ul>
        <div className="Copyright-box my-3">
            <h6>&copy; Copyright Notice & Credits - PolyA2z</h6>
            <p>Website was Designed by Using Bootstrap , all Copyright free images used are from www.pexels.com</p>
            <ul>
            {/* <li>image 1 - (Student photo) by dojangi korinq</li> */}
            {/* <li>image 2 - (Student photo) by dojangi korinq</li>
            <li>image 3 - (Student photo) by dojangi korinq</li>
            <li>image 4 - (Student photo) by dojangi korinq</li> */}
            </ul>
        </div>
        <p>For any Copyright information mail us at - polya2zofficial@gmail.com </p>
        </div>
    </div>
  )
}

export default About